import React from 'react';

export const SectionHeader = (props) => {
    return (
        <div>
            <h2 className={'section-header-name'}>{props.sectionName}</h2>
        </div>
    );
}